import { render } from "./IndividualSensors.vue?vue&type=template&id=0c0c8096&scoped=true&ts=true"
import script from "./IndividualSensors.vue?vue&type=script&lang=ts"
export * from "./IndividualSensors.vue?vue&type=script&lang=ts"

import "./IndividualSensors.vue?vue&type=style&index=0&id=0c0c8096&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0c8096"]])

export default __exports__